import { Component, OnInit } from '@angular/core';
import { NavigateService } from '../../service/navigate.service';
import { EventsService } from '../../service/events.service';

declare var $: any;

@Component({
    selector: 'app-events-index',
    templateUrl: './events-index.component.html',
    styleUrls: ['./events-index.component.styl', '../../share/breadcrumb/breadcrumb.component.styl']
})
export class EventsIndexComponent implements OnInit{
    conferenceList: any = [];   // 会议列表
    page: any = {               // 获取当前页和总页数
        pageIndex: 1,
        pageCount: 1,
    };

    constructor(
        private navigateService: NavigateService,
        private eventService: EventsService
    ){}

    ngOnInit(){
        this.getConferenceList();
        setTimeout(function(){
            $('.wrap-box').css("min-height", $(window).height());
        }, 0);
    }

    // 获取全国会议列表
    getConferenceList(pageIndex = 1){
        this.eventService.getConferences(pageIndex).subscribe(res => {
            if (res.status === 200){
                this.conferenceList = res.rows || [];
                this.page.pageCount = Math.ceil(res.total / 10);
            }
        });
    }

    // 查看详情
    goDetail(id: string | number){
        this.navigateService.push();
        this.navigateService.pushToRoute(`./events/national-Conference/detail/${id}`);
    }
}



// WEBPACK FOOTER //
// /Users/apple/Documents/object/chinaicac-portal/src/app/events/events-index/events-index.component.ts